import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.HomeBuying}-enter {
		.${Layouts.HomeBuying}-background {
			opacity: 0;
		}

		.${Layouts.HomeBuying} {
			opacity: 0;
		}
	}

	&.${Layouts.HomeBuying}-enter-active,
		&.${Layouts.HomeBuying}-enter-done,
		&.${Layouts.HomeBuying}-exit {
		.${Layouts.HomeBuying}-background {
			opacity: 1;
		}

		.${Layouts.HomeBuying} {
			opacity: 1;
		}
	}

	&.${Layouts.HomeBuying}-exit-active {
		.${Layouts.HomeBuying}-background {
			opacity: 0;
		}

		.${Layouts.HomeBuying} {
			opacity: 0;
		}
	}
`;
